import messagingService from "../../api/messagingService";

export const fetchChats = () => {
  return async (dispatch) => {
    let response = await messagingService.getChats();
    if (!response.data.error) {
      dispatch({
        type: "FETCH_CHATS",
        payload: response.data,
      });
    }
  };
};

export const setMessageLoading = (status) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_MESSAGE_LOADING",
      payload: status,
    });
  };
};

export const setCurrentMessages = (groupId, message) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_CURRENT_MESSAGES",
      payload: { groupId, message },
    });
  };
};

export const clearCurrentMessages = (groupId) => {
  return async (dispatch) => {
    dispatch({
      type: "CLEAR_CURRENT_MESSAGES",
      payload: groupId,
    });
  };
};

export const getCurrentMessage = (groupId) => {
  return async (dispatch) => {
    dispatch({
      type: "GET_CURRENT_MESSAGE",
      payload: groupId,
    });
  };
};

export const selectChat = (chat) => ({
  type: "SELECT_CHAT",
  payload: chat,
});

export const selectReplyMessage = (message) => {
  return async (dispatch) => {
    dispatch({
      type: "SELECT_REPLY_MESSAGE",
      payload: message,
    });
  };
};

export const selectForwardedMessage = (message) => {
  return async (dispatch) => {
    dispatch({
      type: "SELECT_FORWARD_MESSAGE",
      payload: message,
    });
  };
};

export const addNewMessage = (
  messageList,
  positionEnd = false,
  groupId,
  increaseUnreadCount = false
) => {
  return async (dispatch) => {
    dispatch({
      type: "ADD_NEW_MESSAGE",
      positionEnd,
      payload: messageList,
      groupId: groupId,
      increaseUnreadCount,
    });
  };
};

export const addChatList = (chatList) => {
  return async (dispatch) => {
    dispatch({
      type: "ADD_CHAT_LIST",
      payload: chatList,
    });
  };
};

export const sendAck = (groupId, messageId, meId, notifyServer = false) => {
  if (notifyServer) {
    return async (dispatch) => {
      dispatch({
        type: "SEND_ACK",
        payload: {
          messageId,
          meId,
        },
      });
    };
  } else {
    return async (dispatch) => {
      dispatch({
        type: "SEND_ACK",
        payload: {
          messageId,
          meId,
        },
      });
      let body = {
        payloadType: "mark_ack",
        payload: {
          time: new Date(),
        },
      };
      await messagingService.sendAck(groupId, messageId, body);
    };
  }
};

export const getPresenceStatus = (userId) => {
  return async (dispatch) => {
    let response = await messagingService.getPresenceStatus(userId);
    if (!response.data.error) {
      dispatch({
        type: "GET_PRESENCE_STATUS",
        payload: response.data,
      });
    }
  };
};

export const fetchChatMessages = (
  groupId,
  lastMessageId = null,
  initial = true,
  count = 20,
  previous = true,
  filters
) => {
  return async (dispatch) => {
    let response = await messagingService.getChatMessages(
      groupId,
      lastMessageId,
      count,
      previous,
      filters ? filters : ""
    );
    if (!response.data.error) {
      dispatch({
        type: "FETCH_CHAT_MESSAGES",
        payload: { list: response.data, initial },
      });
    }
  };
};

export const sendMessage = (groupId, body) => {
  return async (dispatch) => {
    let response = await messagingService.sendMessage(groupId, body);
    if (!response.data.error) {
      dispatch({
        type: "SEND_MESSAGE",
        payload: response.data,
      });
    } else {
      console.log(response.data.error);
    }
  };
};

export const sendForwardedMessage = (
  createAndForward,
  forward,
  selectedForwardMessage,
  me,
  includeAll
) => {
  return async (dispatch) => {
    createAndForward.map((i) => {
      let groupBody = {
        type: "individual",
        participants: [i],
      };
      messagingService.createGroup(groupBody).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "CREATE_GROUP",
            payload: response.data,
          });
          let messageBody = {
            payloadType: "new_message",
            payload: {
              contentType: selectedForwardMessage.payload.contentType,
              reply: includeAll
                ? selectedForwardMessage.payload.reply?.id
                : undefined,
              forwardCount: selectedForwardMessage.payload.forwardCount + 1,
              priority: "normal",
              content: selectedForwardMessage.payload.content,
            },
          };
          dispatch(sendMessage(response.data.id, messageBody));
        }
      });
    });
    forward.map((i) => {
      let messageBody = {
        payloadType: "new_message",
        payload: {
          contentType: selectedForwardMessage.payload.contentType,
          reply: includeAll
            ? selectedForwardMessage.payload.reply?.id
            : undefined,
          forwardCount: selectedForwardMessage.payload.forwardCount + 1,
          priority: "normal",
          content: selectedForwardMessage.payload.content,
        },
      };
      dispatch(sendMessage(i, messageBody));
    });
  };
};

export const deleteMessage = (groupId, messageId, notifyServer = false) => {
  if (notifyServer) {
    return async (dispatch) => {
      dispatch({
        type: "DELETE_MESSAGE",
        payload: messageId,
      });
    };
  } else {
    return async (dispatch) => {
      let response = await messagingService.deleteMessage(groupId, messageId);
      if (!response.data.error) {
        dispatch({
          type: "DELETE_MESSAGE",
          payload: messageId,
        });
      }
    };
  }
};

export const markAsSeen = (groupId, messageId, me, notifyServer = false) => {
  if (notifyServer) {
    return async (dispatch) => {
      dispatch({
        type: "MARK_AS_SEEN",
        payload: {
          groupId: groupId,
          meId: me,
          messageId: messageId,
          // Karşı taraftan gelen tick güncellemesi — kendi unread sayacını düşürme
          skipUnread: true,
        },
      });
    };
  } else {
    return async (dispatch) => {
      dispatch({
        type: "MARK_AS_SEEN",
        payload: {
          groupId: groupId,
          meId: me,
          messageId: messageId,
        },
      });

      let body = {
        payloadType: "mark_seen",
        payload: {
          time: new Date(),
        },
      };
      await messagingService.markAsSeen(groupId, messageId, body);
    };
  }
};

export const markAsSeenBatch = (groupId, messageIds, meId) => {
  return async (dispatch) => {
    const ids = Array.isArray(messageIds)
      ? [...new Set(messageIds.filter(Boolean))]
      : [];
    if (!groupId || !meId || !ids.length) return;

    dispatch({
      type: "MARK_AS_SEEN_BATCH",
      payload: {
        groupId,
        meId,
        messageIds: ids,
      },
    });

    await messagingService.markAsSeenBatch(groupId, {
      payloadType: "mark_seen_batch",
      messageIds: ids,
      payload: {
        time: new Date(),
      },
    });
  };
};

export const starredMessage = (groupId, messageId, userId) => {
  return async (dispatch) => {
    let response = await messagingService.starredMessage(
      groupId,
      messageId,
      userId
    );
    if (!response.data.error) {
      dispatch({
        type: "STARRED_MESSAGE",
        payload: { groupId, messageId, userId },
      });
    } else {
      console.log(response.data.error);
    }
  };
};
export const createGroup = (body) => {
  return async (dispatch) => {
    let response = await messagingService.createGroup(body);
    if (response?.status === 200 && response.data && !response.data.error) {
      const group = response.data.payload || response.data;
      dispatch({
        type: "CREATE_GROUP",
        payload: group,
      });
      // Refresh sidebar chat list so new conversation appears
      dispatch(fetchChats());
    }
  };
};

export const selectParticipantsForForwarded = (p) => {
  return async (dispatch) => {
    dispatch({
      type: "SELECT_PARTICIPANTS_FOR_FORWARDED",
      payload: p,
    });
  };
};

export const selectParticipants = (p) => {
  return async (dispatch) => {
    dispatch({
      type: "SELECT_PARTICIPANTS",
      payload: p,
    });
  };
};
export const findGroup = (groupId) => {
  return async (dispatch) => {
    let response = await messagingService.findGroup(groupId);
    if (!response.data.error) {
      dispatch({
        type: "FIND_GROUP",
        payload: response.data,
      });
    }
  };
};

export const deleteGroup = (groupId) => {
  return async (dispatch) => {
    dispatch({
      type: "DELETE_GROUP",
      payload: groupId,
    });
  };
};

export const editGroup = (
  groupId,
  name = undefined,
  avatar = undefined,
  groupSendMessageSelection = "all"
) => {
  return async (dispatch) => {
    await messagingService.editGroup(groupId, {
      name: name,
      avatar: avatar,
      groupSendMessageSelection: groupSendMessageSelection,
    });
  };
};

export const updateGroup = (group) => {
  return async (dispatch) => {
    dispatch({
      type: "UPDATE_GROUP",
      payload: group,
    });
  };
};

export const addParticipantToGroup = (groupId, body) => {
  return async (dispatch) => {
    let response = await messagingService.addParticipantToGroup(groupId, body);
    if (!response.data.error) {
      dispatch({
        type: "ADD_PARTICIPANT_TO_GROUP",
      });
    }
  };
};

export const deleteParticipantFromGroup = (groupId, body) => {
  return async (dispatch) => {
    let response = await messagingService.deleteParticipantFromGroup(
      groupId,
      body
    );
    if (!response.data.error) {
      dispatch({
        type: "DELETE_PARTICIPANT_FROM_GROUP",
      });
    }
  };
};

export const leaveGroup = (groupId) => {
  return async (dispatch) => {
    let response = await messagingService.leaveGroup(groupId);
    if (!response.data.error) {
      dispatch({
        type: "LEAVE_GROUP",
        payload: groupId,
      });
    }
  };
};

export const addAdminRights = (groupId, body) => {
  return async (dispatch) => {
    let response = await messagingService.addAdminRights(groupId, body);
    if (!response.data.error) {
      dispatch({
        type: "ADD_ADMIN_RIGHTS",
      });
    }
  };
};

export const removeAdminRights = (groupId, body) => {
  return async (dispatch) => {
    let response = await messagingService.removeAdminRights(groupId, body);
    if (!response.data.error) {
      dispatch({
        type: "REMOVE_ADMIN_RIGHTS",
      });
    }
  };
};

export const setUserInformationOpen = (isOpen) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_USER_INFORMATION_OPEN",
      payload: isOpen,
    });
  };
};

export const refreshAvatar = () => {
  return async (dispatch) => {
    dispatch({
      type: "REFRESH_AVATAR",
    });
  };
};

export const invalidateUserAvatar = (userId) => {
  return async (dispatch) => {
    dispatch({
      type: "INVALIDATE_USER_AVATAR",
      payload: userId,
    });
  };
};

export const dropFile = (file) => {
  return async (dispatch) => {
    dispatch({
      type: "DROP_FILE",
      payload: file,
    });
  };
};
export const dragOver = (val) => {
  return async (dispatch) => {
    dispatch({
      type: "DRAG_OVER",
      payload: val,
    });
  };
};

export const archiveGroup = (groupId, userId) => {
  const payload = {
    groupId,
    userId,
  };
  return async (dispatch) => {
    let response = await messagingService.archiveGroup(groupId);
    if (!response.data.error) {
      dispatch({
        type: "ARCHIVE_GROUP",
        payload: payload,
      });
    }
  };
};

export const pinGroup = (groupId) => {
  return async (dispatch) => {
    let response = await messagingService.pinGroup(groupId);
    if (!response.data.error) {
      dispatch({
        type: "PIN_GROUP",
        payload: response.data,
      });
    }
  };
};

export const getLastChats = () => {
  return async (dispatch) => {
    let response = await messagingService.getLastChats();
    if (!response.data.error) {
      dispatch({
        type: "FETCH_LAST_CHATS",
        payload: response.data,
      });
    }
  };
};

export const setImageOpen = (id) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_IMAGE_OPEN",
      payload: id,
    });
  };
};
